import { ImStudentRegentsExemptions } from './im-models/im-student-regents-exemptions';
import nvSharedServicesModule from '../services/nv.shared.services.module';
import nvSharedServicesUtils from '../services/utilities/nv.shared.services.utils.module';
import { ImAttendanceRecord } from './im-models/im-attendance-record.service';
import { ImStudentSupport } from './im-models/im-student-support.service';
import { ImSupport } from './im-models/im-support.service';

// Note: this module should never depend on 'nv.shared.models', otherwise you'll set up circular dependencies.
// The 'nv.shared.models' module can depend on this module though.
export default angular
  .module('nv.shared.static-models', [nvSharedServicesUtils, nvSharedServicesModule])
  .service('ImStudentRegentsExemptions', ImStudentRegentsExemptions)
  .service('ImSupport', ImSupport)
  .service('ImStudentSupport', ImStudentSupport)
  .service('ImAttendanceRecord', ImAttendanceRecord).name;
